import { c as _c } from "react/compiler-runtime";
import { ChatKit as Chat, useChatKit } from '@openai/chatkit-react';
import Script from 'next/script';
import { useEffect, useState } from 'react';
import { twJoin, twMerge } from 'tailwind-merge';
import { ChatKitStarIcon, ChatKitStarFilledIcon, ChatKitArrowIcon, ChatKitArrowFilledIcon } from './icons';
import { useChatKitActions } from './hooks';
import useMediaQuery from 'shared/hooks/use-media-query';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { LoadingIcon } from '@systemeio/ui/icons';
export const ChatKit = () => {
  const $ = _c(93);
  const [isShown, setIsShown] = useState(false);
  const [isRendered, setIsRendered] = useState(false);
  const [isChatReady, setIsChatReady] = useState(false);
  const {
    t
  } = useLocoTranslation();
  const {
    isMD
  } = useMediaQuery();
  const {
    getClientSecret,
    escalateSupportRequest
  } = useChatKitActions();
  let t0;
  if ($[0] !== t) {
    t0 = t("dashboard.chat_kit.disclaimer");
    $[0] = t;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== t0) {
    t1 = {
      text: t0
    };
    $[2] = t0;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      color: {
        accent: {
          primary: "hsla(236, 82%, 64%, 1)",
          level: 1
        }
      }
    };
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("dashboard.chat_kit.placeholder");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = {
      placeholder: t3
    };
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("dashboard.chat_kit.greeting");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t) {
    t6 = t("dashboard.chat_kit.prompt_create_funnel");
    $[11] = t;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t) {
    t7 = t("dashboard.chat_kit.prompt_create_funnel");
    $[13] = t;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = {
      icon: "circle-question",
      label: t6,
      prompt: t7
    };
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t("dashboard.chat_kit.prompt_import_contacts");
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t) {
    t10 = t("dashboard.chat_kit.prompt_import_contacts");
    $[20] = t;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t10 || $[23] !== t9) {
    t11 = {
      icon: "circle-question",
      label: t9,
      prompt: t10
    };
    $[22] = t10;
    $[23] = t9;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== t) {
    t12 = t("dashboard.chat_kit.prompt_create_website");
    $[25] = t;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  let t13;
  if ($[27] !== t) {
    t13 = t("dashboard.chat_kit.prompt_create_website");
    $[27] = t;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t12 || $[30] !== t13) {
    t14 = {
      icon: "circle-question",
      label: t12,
      prompt: t13
    };
    $[29] = t12;
    $[30] = t13;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== t) {
    t15 = t("dashboard.chat_kit.prompt_send_newsletter");
    $[32] = t;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t) {
    t16 = t("dashboard.chat_kit.prompt_send_newsletter");
    $[34] = t;
    $[35] = t16;
  } else {
    t16 = $[35];
  }
  let t17;
  if ($[36] !== t15 || $[37] !== t16) {
    t17 = {
      icon: "circle-question",
      label: t15,
      prompt: t16
    };
    $[36] = t15;
    $[37] = t16;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t11 || $[40] !== t14 || $[41] !== t17 || $[42] !== t8) {
    t18 = [t8, t11, t14, t17];
    $[39] = t11;
    $[40] = t14;
    $[41] = t17;
    $[42] = t8;
    $[43] = t18;
  } else {
    t18 = $[43];
  }
  let t19;
  if ($[44] !== t18 || $[45] !== t5) {
    t19 = {
      greeting: t5,
      prompts: t18
    };
    $[44] = t18;
    $[45] = t5;
    $[46] = t19;
  } else {
    t19 = $[46];
  }
  let t20;
  if ($[47] !== getClientSecret) {
    t20 = {
      async getClientSecret() {
        const {
          clientSecret
        } = await getClientSecret();
        return clientSecret;
      }
    };
    $[47] = getClientSecret;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== escalateSupportRequest) {
    t21 = async invocation => {
      if (invocation.name === "create_support_request") {
        ;
        try {
          await escalateSupportRequest(invocation.params);
          return {
            success: true
          };
        } catch (t22) {
          return {
            success: false
          };
        }
      }
      return {
        success: false
      };
    };
    $[49] = escalateSupportRequest;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  let t22;
  if ($[51] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = () => {
      setIsChatReady(true);
    };
    $[51] = t22;
  } else {
    t22 = $[51];
  }
  let t23;
  if ($[52] !== t1 || $[53] !== t19 || $[54] !== t20 || $[55] !== t21 || $[56] !== t4) {
    t23 = {
      disclaimer: t1,
      theme: t2,
      composer: t4,
      startScreen: t19,
      api: t20,
      onClientTool: t21,
      onReady: t22
    };
    $[52] = t1;
    $[53] = t19;
    $[54] = t20;
    $[55] = t21;
    $[56] = t4;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  const {
    control
  } = useChatKit(t23);
  let t24;
  let t25;
  if ($[58] !== isMD || $[59] !== isShown) {
    t24 = () => {
      const htmlElement = document.documentElement;
      if (isShown && !isMD) {
        htmlElement.style.overflow = "hidden";
      } else {
        htmlElement.style.overflow = "";
      }
      return () => {
        htmlElement.style.overflow = "";
      };
    };
    t25 = [isShown, isMD];
    $[58] = isMD;
    $[59] = isShown;
    $[60] = t24;
    $[61] = t25;
  } else {
    t24 = $[60];
    t25 = $[61];
  }
  useEffect(t24, t25);
  let t26;
  if ($[62] !== isRendered || $[63] !== isShown) {
    t26 = () => {
      if (!isRendered) {
        setIsRendered(true);
        setIsShown(true);
      } else {
        setIsShown(!isShown);
      }
    };
    $[62] = isRendered;
    $[63] = isShown;
    $[64] = t26;
  } else {
    t26 = $[64];
  }
  const onAIButtonClickHandler = t26;
  let t27;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <Script src="https://cdn.platform.openai.com/deployments/chatkit/chatkit.js" async={true} />;
    $[65] = t27;
  } else {
    t27 = $[65];
  }
  const t28 = isShown && !isChatReady && "animate-pulse";
  const t29 = isMD ? "bottom-16" : "bottom-32";
  let t30;
  if ($[66] !== t28 || $[67] !== t29) {
    t30 = twMerge(" from-6.36% via-23.9% to-70.14% group fixed right-2 bottom-16 z-50 flex h-12 w-12 rounded-full bg-gradient-to-br from-[#4EB2F4] via-[#4076F9] to-[#7A3ADB] transition transition-all hover:scale-110", t28, t29);
    $[66] = t28;
    $[67] = t29;
    $[68] = t30;
  } else {
    t30 = $[68];
  }
  const t31 = isShown && !isChatReady;
  let t32;
  if ($[69] !== isShown) {
    t32 = !isShown && <><ChatKitStarIcon style={{
        width: 28
      }} className={twMerge("absolute left-1/2 bottom-1/2 -translate-x-1/2 translate-y-1/2 opacity-100 transition-all duration-300 ease-in-out group-hover:opacity-0")} /><ChatKitStarFilledIcon style={{
        width: 40
      }} className={twMerge("absolute left-1/2 bottom-1/2 -translate-x-1/2 translate-y-1/2 opacity-0 transition-all duration-300 ease-in-out group-hover:opacity-100")} /></>;
    $[69] = isShown;
    $[70] = t32;
  } else {
    t32 = $[70];
  }
  let t33;
  if ($[71] !== isChatReady || $[72] !== isShown) {
    t33 = isShown && !isChatReady && <span className={twMerge("absolute left-2/3 bottom-1/2 -translate-x-1/2 translate-y-1/2 opacity-100 transition-all duration-300 ease-in-out group-hover:opacity-0")}><LoadingIcon style={{
        width: 24,
        color: "white"
      }} /></span>;
    $[71] = isChatReady;
    $[72] = isShown;
    $[73] = t33;
  } else {
    t33 = $[73];
  }
  let t34;
  if ($[74] !== isChatReady || $[75] !== isShown) {
    t34 = isShown && isChatReady && <><ChatKitArrowIcon style={{
        width: 28
      }} className={twMerge("absolute left-1/2 bottom-1/2 -translate-x-1/2 translate-y-1/2 opacity-100 transition-all duration-300 ease-in-out group-hover:opacity-0")} /><ChatKitArrowFilledIcon style={{
        width: 40
      }} className={twMerge("absolute left-1/2 bottom-1/2 -translate-x-1/2 translate-y-1/2 opacity-0 transition-all duration-300 ease-in-out group-hover:opacity-100")} /></>;
    $[74] = isChatReady;
    $[75] = isShown;
    $[76] = t34;
  } else {
    t34 = $[76];
  }
  let t35;
  if ($[77] !== onAIButtonClickHandler || $[78] !== t30 || $[79] !== t31 || $[80] !== t32 || $[81] !== t33 || $[82] !== t34) {
    t35 = <button onClick={onAIButtonClickHandler} className={t30} disabled={t31}>{t32}{t33}{t34}</button>;
    $[77] = onAIButtonClickHandler;
    $[78] = t30;
    $[79] = t31;
    $[80] = t32;
    $[81] = t33;
    $[82] = t34;
    $[83] = t35;
  } else {
    t35 = $[83];
  }
  let t36;
  if ($[84] !== control || $[85] !== isChatReady || $[86] !== isMD || $[87] !== isRendered || $[88] !== isShown) {
    t36 = isRendered && <div className={twJoin("z-49 md:shadow-around-sm fixed h-full w-full transition-all duration-300 md:h-[600px] md:w-[320px] md:overflow-hidden md:rounded-md", isMD ? "right-10 bottom-14" : "left-0 bottom-0 right-0 top-0", isShown && isChatReady ? "scale-100 opacity-100" : "pointer-events-none scale-0 opacity-0")}><Chat control={control} /></div>;
    $[84] = control;
    $[85] = isChatReady;
    $[86] = isMD;
    $[87] = isRendered;
    $[88] = isShown;
    $[89] = t36;
  } else {
    t36 = $[89];
  }
  let t37;
  if ($[90] !== t35 || $[91] !== t36) {
    t37 = <>{t27}{t35}{t36}</>;
    $[90] = t35;
    $[91] = t36;
    $[92] = t37;
  } else {
    t37 = $[92];
  }
  return t37;
};